import { Badge } from '@mlm/ui';

/**
 * "All branches" marker for a dashboard figure that CANNOT narrow to the
 * selected branch — commissions, wallet balances, payouts, KYC, member counts,
 * leaderboards. Those live in tables with no branch column (`ledger_entries`,
 * `slot_wallets`, `payout_requests`, `users`, `slots`), and a commission is
 * paid to an upline who may sit in another branch entirely, so there is nothing
 * honest to filter on.
 *
 * The alternative — hiding those cards while filtered — was considered and
 * rejected: the operator loses the tenant-wide view with no way back, and the
 * page changes shape on every toggle. Marking is the truthful middle.
 *
 * Renders NOTHING when no branch is applied, so the unfiltered dashboard is
 * pixel-identical to what it was before this filter existed.
 */
export function TenantWideBadge({
  show,
  className,
  /** Override when the badge annotates PART of a widget (e.g. one chart series). */
  label = 'All branches',
  title = 'This figure has no branch dimension, so it stays tenant-wide while a branch filter is active.',
}: {
  show: boolean;
  className?: string;
  label?: string;
  title?: string;
}) {
  if (!show) return null;
  return (
    <Badge variant="muted" className={className} title={title}>
      {label}
    </Badge>
  );
}
